export default __webpack_public_path__ + "static/2-d3c1d16c82f09e6fc28c32b8ffc0782b.png";